import type { ToolResultUrl, ToolResultUrlApiResponse } from '../interfaces/tool-result.interface'
import { agentsApiSlice } from './agents-api.store'

const TOOL_RESULTS_API = '/api/v1/tool-results'

const toolResultEndpoints = agentsApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getToolResultPresignedUrl: builder.query<ToolResultUrl, string>({
      query: (s3Key) => ({
        url: TOOL_RESULTS_API,
        params: { s3_key: s3Key },
      }),
      transformResponse: (response: ToolResultUrlApiResponse): ToolResultUrl => ({
        downloadUrl: response.download_url,
      }),
    }),
  }),
})

export const { useLazyGetToolResultPresignedUrlQuery } = toolResultEndpoints
